import { render } from "./ExportElementButton.vue?vue&type=template&id=a67f7dc4"
import script from "./ExportElementButton.vue?vue&type=script&lang=js"
export * from "./ExportElementButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__